import React, { forwardRef } from 'react';
import { Icon } from 'react-feather';
import PropTypes from 'prop-types';

const MoneyCircle: Icon = forwardRef(
  ({ color = 'currentColor', size = 24 }) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.0476 6.66666H8.04765C7.60562 6.66666 7.1817 6.84225 6.86914 7.15481C6.55658 7.46737 6.38098 7.8913 6.38098 8.33332C6.38098 8.77535 6.55658 9.19927 6.86914 9.51183C7.1817 9.8244 7.60562 9.99999 8.04765 9.99999H11.381C11.823 9.99999 12.2469 10.1756 12.5595 10.4881C12.8721 10.8007 13.0476 11.2246 13.0476 11.6667C13.0476 12.1087 12.8721 12.5326 12.5595 12.8452C12.2469 13.1577 11.823 13.3333 11.381 13.3333H6.38098M9.71432 15V4.99999M18.0476 9.99999C18.0476 14.6024 14.3167 18.3333 9.71432 18.3333C5.11194 18.3333 1.38098 14.6024 1.38098 9.99999C1.38098 5.39762 5.11194 1.66666 9.71432 1.66666C14.3167 1.66666 18.0476 5.39762 18.0476 9.99999Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
);

MoneyCircle.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

MoneyCircle.displayName = 'MoneyCircle';

export default MoneyCircle;
